import React from "react";
import { Button } from "src/components/Button";
import { Text } from "src/components/Text";
import {
  ModalManager,
  Modal,
  ModalContent,
  ModalFooter,
} from "src/components/Modal";
import { useTranslation } from "src/hooks";
import { ListEl, ListContainerEl } from "../OwnerInfo/OwnerInfo.modal";

type Props = {
  purpose: "akta" | "menkeh";
  showModal: boolean;
  onClose: () => void;
};

export const UploadTooltipModal = ({ purpose, showModal, onClose }: Props) => {
  const translate = useTranslation();
  const tooltipContents = translate(`tooltip.${purpose}.points`);
  return (
    <ModalManager showModal={showModal} onClose={onClose}>
      <Modal style={{ height: "auto" }}>
        <ModalContent>
          <Text fontWeight="demi" marginBottomL marginTopS>
            {translate(`tooltip.${purpose}.title`)}
          </Text>
          <ListContainerEl>
            {Array.isArray(tooltipContents) &&
              tooltipContents.map((content: string, index: number) => {
                return <ListEl key={index}>{content}</ListEl>;
              })}
          </ListContainerEl>
        </ModalContent>
        <ModalFooter>
          <Button onClick={onClose}>{translate("tooltip.cta")}</Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
